import { Pipe, PipeTransform } from "@angular/core";


@Pipe({ name: "ordinalSup" })
export class OrdinalSupPipe implements PipeTransform {
  
  transform(value: string) {
    if (!value) return '';
    return value.replace(/\b(\d+)(st|nd|rd|th)\b/g, (_, num, suffix) => {
      return `${num}<sup>${suffix}</sup>`;
    });
  }
}